// removed by extract-text-webpack-plugin
module.exports = {"modalLoading":"qempo_DeleteModal_modalLoading-2ZEBKOd","deleteOrderModal":"qempo_DeleteModal_deleteOrderModal-1dFU1Il","title":"qempo_DeleteModal_title-1OXZR3z","btn":"qempo_DeleteModal_btn-3izt67x"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/DeleteModal/DeleteModal.scss
// module id = 1750
// module chunks = 0